import { useEffect, useState } from "react";
import { ActionIcon } from "@mantine/core";
import { IconX } from "@tabler/icons-react";
import ChatbaseWidget from "./ChatbaseWidget";

const CHATBASE_BUTTON_ID = "chatbase-bubble-button";
const CHATBASE_WINDOW_ID = "chatbase-bubble-window";
const SESSION_STORAGE_KEY = "chatbase-dismissed";

function getInitialDismissed(): boolean {
  if (typeof window === "undefined") return false;
  return sessionStorage.getItem(SESSION_STORAGE_KEY) === "true";
}

function hideChatbaseElements() {
  const button = document.getElementById(CHATBASE_BUTTON_ID);
  const windowEl = document.getElementById(CHATBASE_WINDOW_ID);
  if (button) button.style.display = "none";
  if (windowEl) windowEl.style.display = "none";
}

export default function ChatbaseWithDismiss() {
  const [isDismissed, setIsDismissed] = useState(getInitialDismissed);

  useEffect(() => {
    if (!isDismissed) return;
    hideChatbaseElements();
    const observer = new MutationObserver(() => hideChatbaseElements());
    observer.observe(document.body, { childList: true, subtree: true });
    return () => observer.disconnect();
  }, [isDismissed]);

  const handleDismiss = () => {
    sessionStorage.setItem(SESSION_STORAGE_KEY, "true");
    setIsDismissed(true);
  };

  if (isDismissed) {
    return <ChatbaseWidget />;
  }

  return (
    <>
      <ChatbaseWidget />
      <ActionIcon
        size="sm"
        variant="subtle"
        color="gray"
        onClick={handleDismiss}
        aria-label="Hide chat"
        style={{
          position: "fixed",
          bottom: 70,
          right: 4,
          zIndex: 9999,
        }}
      >
        <IconX size={16} />
      </ActionIcon>
    </>
  );
}
